export default "يكون\nأو\nأين\nماذا\nكيف\nكم عدد\nكم ثمن\nيجب\nيستطيع"